<template>
  <div>
    <Header :selectedApp="selectedApp"></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <h2>Square Configurations</h2>

        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-between align-items-center">
            <a role="button" class="procricket-btn mb-3" @click="redirectToCreate">Create New Entry</a>
          </div>
          <input
              type="text"
              class="form-control mb-3"
              placeholder="Search Square Configurations..."
              v-model="searchText"
              style="width: 20%; position: relative;"
          >
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th class="col-1" @click="toggleSort('squareConfigurationId')">Square Configuration Id</th>
              <th class="col-1" @click="toggleSort('squareName')">Square Name</th>
              <th class="col-1" @click="toggleSort('accessToken')">Access Token</th>
              <th class="col-1" @click="toggleSort('locationId')">Location Id</th>
              <th class="col-1" @click="toggleSort('webhookSignatureKey')">Webhook Signature Key</th>
              <th class="col-2" @click="toggleSort('webhookUrl')">Webhook URL</th>
              <th class="col-2" @click="toggleSort('redirectUrl')">Redirect URL</th>
              <th class="col-1" @click="toggleSort('apiBase')">API Base</th>
              <th class="col-1" @click="toggleSort('application')">Application</th>
              <th class="col-1" @click="toggleSort('percentage')">Percentage</th>
              <th class="col-1" @click="toggleSort('active')">Active</th>
              <th class="col-1" @click="toggleSort('status')">Status</th>
              <th class="col-1">Edit</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="config in sortData" :key="config.squareConfigurationId">
              <td class="col-1 text-truncate" v-html="truncateText(config.squareConfigurationId, 30)"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.squareName, 30)" @click="selectText" :data-text="config.squareName"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.accessToken, 30)" @click="selectText" :data-text="config.accessToken"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.locationId, 30)" @click="selectText" :data-text="config.locationId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.webhookSignatureKey, 30)" @click="selectText" :data-text="config.webhookSignatureKey"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.webhookUrl, 70)" :title="config.webhookUrl" @click="selectText" :data-text="config.webhookUrl"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.redirectUrl, 70)" :title="config.redirectUrl" @click="selectText" :data-text="config.redirectUrl"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.apiBase, 30)" @click="selectText" :data-text="config.apiBase"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.application, 30)" @click="selectText" :data-text="config.application"></td>
              <td class="col-1 text-truncate">{{ config.percentage }}%</td>
              <td class="col-1 text-truncate">{{ config.active }}</td>
              <td class="col-1 text-truncate">{{ config.status }}</td>
              <td class="col-1 centered">
                <router-link :to="{ name: 'SquareEdit', params: { id: config.squareConfigurationId, squareName: config.squareName, accessToken: config.accessToken, locationId: config.locationId, webhookSignatureKey: config.webhookSignatureKey, webhookUrl: config.webhookUrl, redirectUrl: config.redirectUrl, apiBase: config.apiBase, application: config.application, percentage: config.percentage, active: config.active, status: config.status } }" class="procricket-btn">
                  Edit
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <p class="text-muted mt-2">
          Percentage, Active and Status are set on the
          <router-link :to="{ name: 'PaymentManagement' }">Payment Management</router-link> page, not here —
          that's also where an account is activated/deactivated.
        </p>

      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";
import Cookies from "js-cookie";

export default {
  name: "SquareConfig",
  components: { Header },
  data() {
    return {
      searchText: "",
      squareConfigList: [],
      sortColumn: "",
      sortDirection: "asc",
      selectedApp: "",
      highlightedElement: null,
    };
  },
  computed: {
    filteredSquareConfigList() {
      const search = this.searchText.toLowerCase().trim();

      let filteredList = this.squareConfigList.filter((config) => {
        return (
            (config.squareName && config.squareName.toLowerCase().includes(search)) ||
            (config.accessToken && config.accessToken.toLowerCase().includes(search)) ||
            (config.locationId && config.locationId.toLowerCase().includes(search)) ||
            (config.webhookSignatureKey && config.webhookSignatureKey.toLowerCase().includes(search)) ||
            (config.webhookUrl && config.webhookUrl.toLowerCase().includes(search)) ||
            (config.redirectUrl && config.redirectUrl.toLowerCase().includes(search)) ||
            (config.apiBase && config.apiBase.toLowerCase().includes(search)) ||
            (config.application && config.application.toLowerCase().includes(search))
        );
      });

      if (this.sortColumn) {
        const direction = this.sortDirection === "asc" ? 1 : -1;
        filteredList = filteredList.sort((a, b) => {
          const rawA = a?.[this.sortColumn];
          const rawB = b?.[this.sortColumn];
          const valueA = rawA === null || rawA === undefined ? "" : String(rawA).toLowerCase();
          const valueB = rawB === null || rawB === undefined ? "" : String(rawB).toLowerCase();
          if (valueA < valueB) return -1 * direction;
          if (valueA > valueB) return 1 * direction;
          return 0;
        });
      }

      if (this.selectedApp !== "") {
        filteredList = filteredList.filter((item) => item.application === this.selectedApp);
      }

      return filteredList;
    },
    sortData() {
      return this.filteredSquareConfigList;
    },
  },
  created() {
    this.doLoadSquareConfig();
    document.addEventListener("click", (event) => this.handleClickAnywhere(event));

    const appCookie = Cookies.get("application");
    if (appCookie) this.selectedApp = appCookie;

    this.sortColumn = "squareName";
  },
  beforeUnmount() {
    document.removeEventListener("click", (event) => this.handleClickAnywhere(event));
  },
  methods: {
    doLoadSquareConfig() {
      AdminService.getSquareConfigurationList()
          .then((data) => {
            this.squareConfigList = data;
          })
          .catch((error) => {
            console.error("Error loading Square configuration:", error);
          });
    },

    redirectToCreate() {
      this.$router.push({ name: "SquareCreate" });
    },

    truncateText(text, limit) {
      if (text === undefined || text === null) return null;
      return text.length > limit ? text.substring(0, limit) + "..." : text;
    },

    async selectText(event) {
      const originalText = event.target.getAttribute("data-text");
      try {
        await navigator.clipboard.writeText(originalText);
        this.highlightElement(event.target);
      } catch (err) {
        console.error("Failed to copy text: ", err);
      }
    },

    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = "yellow";
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000);
    },

    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = "";
        this.highlightedElement = null;
      }
    },

    handleClickAnywhere() {
      this.removeHighlight();
    },

    toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortColumn = column;
        this.sortDirection = "asc";
      }
    },
  },
};
</script>

<style src="../../assets/style.css"></style>
